export default __webpack_public_path__ + "media/transfer_window/transfer_completed-3-5dbf2f01.mp4";